import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'
import isEmptyObject from '~/helpers/is-empty-object'

export default {
  state: () => createPlatformState(),

  actions: {
    getOccupations ({ commit, state }, prefix) {
      if (!isEmptyObject(state.data)) return Promise.resolve()

      const params = { perPage: 1000, filter: { name: { prefix } } }

      return platformAction({
        client: this.$api.profiles.occupations,
        method: 'getAll',
        commit,
        params,
        logError: this.$logError,
        include: [],
        commitData: true
      })
    }
  },

  mutations: {
    ...platformMutations
  },

  getters: {
    ...platformGetters,

    occupations: ({ data }) => Object.values(data).map(({ name }) => name)
  }
}
